export const appName = "Zažehnuto.cz";
